// @flow

import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';

import {
  createSolutionPartnerProgram,
  createExistingSolutionPartner,
  createLeadSubmissions,
} from '../common/solutionPartner';

const solutionPartner = radio({
  id: 'solutionpartner',
  label: 'Tell us more',
  items: [
    createSolutionPartnerProgram(),
    createExistingSolutionPartner(true),
    createLeadSubmissions(true),
  ],
});

export default solutionPartner;
